import { useEffect, useState } from 'react';

const doAction = (action, event) => {
  var _window, _window$location;

  return typeof action === 'function' && action((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.hash, event);
};
/**
 * @typedef {import('react').SyntheticEvent} SyntheticEvent
 */

/**
 * Calls a function (passing it the current hash) based on the current hash state on mount,
 * and binds it to call it again any time the hash changes.
 *
 * Consider using `useCallback` on the function to minimise adding and removing of event listeners.
 *
 * On Native, this is replaced with a harmless no-op function as there is no direct equivalent.
 *
 * @param {(hash: string, event?: SyntheticEvent) => void} action - a function to act on the current hash on load and when it changes
 * @returns
 */


const useHash = function (action) {
  let isReady = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const [isDone, setIsDone] = useState(false); // Do the action just once when ready after component mount, from hash on page load

  const isToDo = isReady && !isDone;
  useEffect(() => {
    if (isToDo) {
      setIsDone(true);
      doAction(action);
    }
  }, [isToDo, action]); // Bind the action for each hash change; do re-bind if the function changes.

  useEffect(() => {
    const handleChange = event => doAction(action, event);

    window.addEventListener('hashchange', handleChange);
    return () => window.removeEventListener('hashchange', handleChange);
  }, [action]);
};

export default useHash;